/* eslint-disable @next/next/no-page-custom-font */
/* eslint-disable react/no-danger */
import parse from "html-react-parser";
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";
import { offersCss } from "../../utils/stylesUtil/offersCSS";
import { customerReview } from "../../utils/stylesUtil/customerReview";
import { footerCSS } from "../../utils/stylesUtil/footer";
import { bankOfferCSS } from "../../utils/stylesUtil/bankOffer";
import { ab } from "../../public/js/core/abMock";
import { getFontUrl } from "../../utils/helper/utils";

export const appendHeadRouteDT = (props) => {
  const {
    serviceWorker,
    lang,
    ccde,
    robotic_tag,
    validBankOfferSize,
    jsSettingJson,
    state,
    initial_css: initialCSS,
    language,
    appConfig,
    tokenJson,
    giOfferList,
    airline_code: airlineCode = "",
    pageLoad = {},
    isGoibibo = false,
  } = props || {};
  let cssPath;
  let jsPath;
  // let imagePath;
  // let minExt;
  let gliderPath;
  let topOverlayPath;
  let robotMeta = "";
  let serverCssPath = "";
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    serverCssPath = "https://jsak.mmtcdn.com/flights/server";
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    if (robotic_tag) {
      if (state?.listing?.meta?.rKeys.length === 0) {
        robotMeta = '<meta name="robots" content="noindex, nofollow">';
      } else if (state?.listing?.meta?.rKeys.length > 0) {
        robotMeta = '<meta name="robots" content="index, follow">';
      }
    } else {
      robotMeta = '<meta name="robots" content="index, follow">';
    }
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    jsPath = "http://localhost:3000/_next/static/js";
    serverCssPath = "http://localhost:8000/build/server";
    // imagePath = '/images';
    // minExt = '';
  }
  gliderPath = `${jsPath}/glider.min.js`;
  topOverlayPath = isGoibibo ? `${jsPath}/topOverlayGI.min.js` : `${jsPath}/top_overlay.min.js`;
  // let styleSheet = (language === 'ar') ? '<link href="https://fonts.googleapis.com/css2?family=Almarai:wght@300;400;700&display=swap" rel="stylesheet">' : '<link href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;0,900;1,400&display=swap" rel="stylesheet">';
  // styleSheet = parse(styleSheet);
  // styleSheet = transformToHtml(styleSheet);
  const offerCSS = offersCss;
  const customerReviewCSS = customerReview;
  const footerCss = footerCSS;
  const bankOfferCss = bankOfferCSS;
  // const fontCss = fontCSS

  const airlineCodeScript =
    airlineCode && airlineCode.length !== 0
      ? `<script>
    var airlineCode = ${airlineCode};
  </script>`
      : "";

  let windowLang = "window.lang =  'eng'";
  if (language === "ar") {
    windowLang = "window.lang =  'ara'";
  } else if (language === "hi") {
    windowLang = "window.lang =  'hin'";
  }
  const tokenJsonString =
    tokenJson && Object.keys(tokenJson).length !== 0
      ? `var tokenJson = ${JSON.stringify(tokenJson)}`
      : 'var tokenJson = {"dest_city_name":"Mumbai","src_city_code":"DEL","dest_city_code":"BOM","src_city_name":"New Delhi"};';

  const serviceWorkerString = appConfig?.liveMode === true ? serviceWorker : "";

  return (
    <>
      {parse(robotMeta)}
      <link rel="preconnect" href="//jsak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//cssak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//imgak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link rel="preconnect" href="//fonts.googleapis.com" crossOrigin />
      <link href={`${cssPath}/bootstrap.min.css`} rel="stylesheet" />
      {isGoibibo ? (
        <link href={`${cssPath}/dweb-header.min.css`} rel="stylesheet" />
      ) : (
        <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      )}
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS }} />
      <script defer type="text/javascript" src={`${gliderPath}`} />
      <link rel="stylesheet" href={`${serverCssPath}${initialCSS}`} />
      <link
        rel="stylesheet"
        href={getFontUrl(language, isGoibibo)}
        as="style"
        onload="this.onload=null;this.rel='stylesheet'"
      />
      {tokenJson?.tokensList?.airline_code && tokenJson?.tokensList?.airline_code?.length !== 0 ? (
        <script>var airlineCode = {tokenJson.tokensList.airline_code};</script>
      ) : (
        <></>
      )}
      <style dangerouslySetInnerHTML={{ __html: offerCSS }} />
      <style dangerouslySetInnerHTML={{ __html: customerReviewCSS }} />
      <style dangerouslySetInnerHTML={{ __html: footerCss }} />
      <style dangerouslySetInnerHTML={{ __html: bankOfferCss }} />
      <script defer type="text/javascript" src={`${topOverlayPath}`} />
      {parse(airlineCodeScript)}
      <script
        dangerouslySetInnerHTML={{
          __html: ` 
                window.pageLoad = ${JSON.stringify(pageLoad)};
                window.isSeoMain = true;
                var currentDateddMMyy = '${tokenJson?.tokensList?.cheap_ddMMyy || ""}';
                window.seoUrl = "${tokenJson?.tokensList?.url || ""}";
                window.seoScreenParams = {trip : 'oneWay',
                    classtype : 'E',
                    fromcityname : '${tokenJson?.tokensList?.src_city_name || ""}',
                    tocityname   : '${tokenJson?.tokensList?.dest_city_name || ""}',
                    fromcity : '${tokenJson?.tokensList?.src_city_code || ""}',
                    tocity   : '${tokenJson?.tokensList?.dest_city_code || ""}',
                    childcount : 0,
                    infantcount : 0,
                    adultcount : 1,
                    depdate : '${tokenJson?.tokensList?.cheap_MMddyyyy || ""}',
                    isIntl : false,
                    airlinecode : '${tokenJson?.tokensList?.airline_code || ""}'};
                window.AB=${JSON.stringify(ab)};
                window.urlParams = "?cabinClass=E&ccde=${ccde}&deviceMemory=8&intl=false&itinerary=${
            tokenJson?.tokensList?.src_city_code
          }-${tokenJson?.tokensList?.dest_city_code}-${
            tokenJson?.tokensList?.ddMMyyyy
          }&lang=${lang}&msExperiments=showFare%3Atrue&msv=2&paxType=A-1_C-0_I-0&ssr=true&tripType=O&pwa=false${isGoibibo ? "&cmpid=SEO": "&cmp=SEO"}";
                window.showLeaveIntent = true;
                window.validBankOfferSize = ${validBankOfferSize};
                window.isPWA = false;
                window.isProduction = 'true';
                window.page = "search";
                window.countryCode = '${ccde}';
                window.ccde = '${ccde}';
                ${windowLang};
                window.jsSetting = ${JSON.stringify(jsSettingJson)};
                var jsSettingJson = ${JSON.stringify(jsSettingJson)};
                ${tokenJsonString}`,
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: `${serviceWorkerString}` }} />
      <script
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener('load', function () {
        new Glider(document.querySelector('.bankOfferItemWrapper'), {
                slidesToShow: 1,
                slidesToScroll: 1,
                scrollLock: true,
                dots: '',
                arrows: {
                    prev: '.btn-prev',
                    next: '.btn-next',
                },

                responsive: [
                    {
                        breakpoint: 775,
                        settings: {
                            slidesToScroll: 'auto',
                            itemWidth: 150,
                            duration: 0.80
                        }
                    }, {
                        breakpoint: 1024,
                        scrollLock: true,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.80,

                        }
                    }
                ]
            },
        );
    });`,
        }}
      />
    </>
  );
};
